export default __webpack_public_path__ + "static/media/sldlogo.6bc88d20.png";